export const HEADER_HEIGHT = 73;
export const TOUCH_TIMEOUT = 10;
